import {
  Box,
  Checkbox,
  CheckboxProps,
  Theme,
  withStyles,
} from '@material-ui/core';
import React from 'react';
import { green, grey } from 'globals/colors';

export const StyledCheckbox = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[300],
    '&$checked': {
      color: green.MAIN,
    },
    '& svg': {
      width: spacing(4),
      height: spacing(4),
    },
  },
  checked: {},
}))((props: CheckboxProps) => {
  return (
    <Checkbox
      color="default"
      icon={
        !props.checked ? (
          <Box
            width={32}
            height={32}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              width={24}
              height={24}
              borderRadius={5}
              border={`1px solid ${grey.V4}`}
            />
          </Box>
        ) : undefined // fist icon custom, second original
      }
      {...props}
    />
  );
});
